import SceButton from '../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from '../twoFactorAuthenticationStrings';
import classes from '../twoFactorAuthContainer.scss';

function ConfirmationPopup(props) {
    let strings = getLocalizedStrings('twoFactorAuthenticationStrings');
    let verifiedIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Verified_Symbol.svg';
    return (
        <div className={classes.card}>   
        <div className={[classes.verified, 'sce-center-alg', "sce-content-row"].join(" ")}>
            <div className={classes.verifiedIcon}> <img src={verifiedIcon} alt="Verified Icon" />
                <div className={classes.verifiedText}> {props.isEmail ? strings.emailVerified : strings.phoneVerified} </div>
                <SceButton buttonType="primary" value="OK" onClick={()=>props.handleCloseClick("ok")} />
            </div>
        </div>
        </div>
    );
}

export default ConfirmationPopup;